import chroma from "chroma-js";

import useProperties from "@/hooks/use-properties";

import { ColorLabels, getInvertedColor } from "./colors";

export * from "./colors";

export const useInvertedColor = getInvertedColor;

type Props = {
  style?: Record<string, unknown>;
  _inheritColorIndex?: number;
  inheritColorIndex?: number;
};

function byLabel(fn) {
  return function (index: ColorLabels): string {
    return fn({ inheritColorIndex: index });
  };
}

export const getColorByLabel = byLabel(useColor);

export default function useColor<T>(
  props: T & Props,
  property?: "background" | "backgroundColor" | "color"
) {
  const { colors } = useProperties();
  let color = colors[0];
  if (props[property]) {
    color = props[property] as string;
  } else if (props.style && props.style[property]) {
    color = props.style[property] as string;
  } else if (props?._inheritColorIndex !== undefined) {
    color = colors[props._inheritColorIndex] || colors[0];
  } else if (props?.inheritColorIndex !== undefined) {
    color = colors[props.inheritColorIndex] || colors[0];
  }
  if (chroma.valid(color)) {
    return chroma(color).hex();
  }
}
